import React, { useEffect, useState } from 'react';
import { AppRemixIcon, AppNoInfo, AppDeleteModal } from '@/layout/AppComponents';
import styled from 'styled-components';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../../routing/helpers/router';
import Translator from '../../../../../components/helpers/Translator';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import colors from '../../../../../../constants/colors';
import AppModal from '../../../../../components/Modal/AppModal';
import AppTextEditor from '../../../../../components/form/Texts/AppTextEditor';
import useIsMounted from '../../../../../components/hooks/useIsMounted';

const SanctionTab = (props) => {
  const { plantObligationID } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const sanction = useSelector((s) => s.currentPage?.sanctionTabs?.[plantObligationID]);
  const [edition, setEdition] = useState();
  const [remove, setRemove] = useState();
  const [isLoading, setIsLoading] = useState(false);

  // > LOAD INFORMATION TAB
  useEffect(() => {
    if (!sanction) {
      setIsLoading(true);
      (async () => {
        try {
          const response = await axios.post(
            axiosPath("api_r_user_module_legalCompliance_sanction_tab"),
            { moduleBridgeHex, plantHex, plantObligationID }
          );
          if (isMounted.current) {
            dispatch(
              currentPageAction.change("sanctionTabs", {
                [plantObligationID]: response.data,
              })
            );
            setIsLoading(false);
          }
        } catch (err) {}
      })();
    }
  }, []);
  // < LOAD INFORMATION TAB

  // > EDIT
  const handleEdit = async (values) => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_sanction_edit"),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
          type: edition,
          ...values,
        }
      );
      if (isMounted.current) {
        dispatch(
          currentPageAction.change("sanctionTabs", {
            [plantObligationID]: response.data,
          })
        );
        setEdition(undefined);
      }
    } catch (err) {}
  };
  // < EDIT

  // < REMOVE
  const handleRemove = async () => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_sanction_remove"),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
          type: remove,
        }
      );
      if (isMounted.current) {
        dispatch(currentPageAction.change('sanctionTabs', { [plantObligationID]: response.data }));
        setRemove(undefined);
      }
    } catch (err) {}
  };
  // > REMOVE

  if (isLoading) return <AppNoInfo minHeight={300} />;

  return (
    <SanctionTabContainer>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 mb-3">
            <SanctionContainer>
              <h3>
                <Translator
                  file="user"
                  name="user.obligations.location.penalty"
                />
              </h3>

              <div style={{ height: '80px', overflowY: 'scroll' }}>
                <div
                  dangerouslySetInnerHTML={{ __html: sanction?.sanction?.text }}
                />

                {sanction?.sanction?.subSanctions?.length > 0 && (
                  <h3 className="mt-5 mb-0">Nota:</h3>
                )}

                <ul className="pl-3 mt-2">
                  {sanction?.sanction?.subSanctions?.map((subSanction) => (
                    <li key={subSanction.id}>
                      <div >
                        <p className="text-primary">{subSanction?.locations}</p>
                        <div
                          className="pr-2"
                          dangerouslySetInnerHTML={{
                            __html: subSanction?.name,
                          }}
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </SanctionContainer>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6 mb-3">
            <Container>
              <h3>
                <Translator
                  file="user"
                  name="user.obligations.location.probability"
                />
                <span
                  className="float-right pointer"
                  title={ReactDOMServer.renderToString(
                    <Translator file="user" name="user.remove" />,
                  )}
                  onClick={() => setRemove('probability')}
                >
                  <AppRemixIcon icon="close" size={16} />
                </span>
                <span
                  className="float-right pointer"
                  title={ReactDOMServer.renderToString(
                    <Translator file="general" name="general.edit" />,
                  )}
                  onClick={() => setEdition('probability')}
                >
                  <AppRemixIcon icon="edit" size={16} />
                </span>
              </h3>
              <div
                dangerouslySetInnerHTML={{ __html: sanction?.probability }}
                style={{ height: '80px', overflowY: 'scroll' }}
              />
            </Container>
          </div>
          <div className="col-sm-6 mb-3">
            <Container>
              <h3>
                <Translator
                  file="user"
                  name="user.obligations.location.severity"
                />
                <span
                  className="float-right pointer"
                  title={ReactDOMServer.renderToString(
                    <Translator file="user" name="user.remove" />,
                  )}
                  onClick={() => setRemove('severity')}
                >
                  <AppRemixIcon icon="close" size={16} />
                </span>
                <span
                  className="float-right pointer"
                  title={ReactDOMServer.renderToString(
                    <Translator file="general" name="general.edit" />,
                  )}
                  onClick={() => setEdition('severity')}
                >
                  <AppRemixIcon icon="edit" size={16} />
                </span>
              </h3>
              <div
                dangerouslySetInnerHTML={{ __html: sanction?.severity }}
                style={{ height: '80px', overflowY: 'scroll' }}
              />
            </Container>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 mb-3">
            <Container>
              <h3>
                <Translator
                  file="module-correctiveActions"
                  name="module.ca.gcl-take-action"
                />
                <span
                  className="float-right pointer"
                  title={ReactDOMServer.renderToString(
                    <Translator file="user" name="user.remove" />,
                  )}
                  onClick={() => setRemove('action')}
                >
                  <AppRemixIcon icon="close" size={16} />
                </span>
                <span
                  className="float-right pointer"
                  title={ReactDOMServer.renderToString(
                    <Translator file="general" name="general.edit" />,
                  )}
                  onClick={() => setEdition('action')}
                >
                  <AppRemixIcon icon="edit" size={16} />
                </span>
              </h3>
              <div
                dangerouslySetInnerHTML={{ __html: sanction?.action }}
                style={{ height: '80px', overflowY: 'scroll' }}
              />
            </Container>
          </div>
        </div>
      </div>
      <AppModal
        show={!!edition}
        onClose={() => setEdition(undefined)}
        title={<Translator file="general" name="general.edit" />}
      >
        <Formik
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize
          initialValues={{
            text:
              edition === 'probability'
                ? sanction?.probability
                : edition === 'severity'
                  ? sanction?.severity
                  : edition === 'action'
                    ? sanction?.action
                    : '',
          }}
          onSubmit={handleEdit}
        >
          {({ setFieldValue, handleSubmit, values, isSubmitting }) => (
            <>
              <AppTextEditor
                onChange={(v) => setFieldValue('text', v)}
                value={values.text}
                height={200}
              />
              <span
                className="btn btn-success float-right mt-3"
                onClick={() => (isSubmitting ? undefined : handleSubmit())}
                disabled={isSubmitting}
              >
                <Translator file="general" name="general.update" />
              </span>
            </>
          )}
        </Formik>
      </AppModal>
      <AppDeleteModal
        show={!!remove}
        title={<Translator file="user" name="user.remove" />}
        onConfirm={() => handleRemove()}
        onClose={() => setRemove(undefined)}
      />
    </SanctionTabContainer>
  );
};
export default SanctionTab;

const SanctionTabContainer = styled.div`
  height: 400px;
`;

const SanctionContainer = styled.div`
  border: 1px solid ${colors.grey300};
  padding: 4px;
`;

const Container = styled.div`
  border: 1px solid ${colors.grey300};
  padding: 4px;
`;
